import { useState } from "react";

export const useFullScreenImage = (defaultIndex = 0) => {
  const [displayedImageIndex, setDisplayedImageIndex] = useState(defaultIndex);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const setSelectedIndex = (index: number) => {
    setDisplayedImageIndex(index);
  };

  const goLeft = () => {
    setDisplayedImageIndex((index) => Math.max(0, index - 1));
  };

  const goRight = () => {
    setDisplayedImageIndex((index) => index + 1);
  };

  const openFullScreen = () => {
    setIsFullScreen(true);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
  };

  return {
    displayedImageIndex,
    isFullScreen,
    setSelectedIndex,
    goLeft,
    goRight,
    openFullScreen,
    closeFullScreen,
  };
};
